import { Pipe, PipeTransform, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
@Pipe({
  name: 'compare',
  pure: false,
  standalone: true,
})
export class ComparePipe implements PipeTransform {
    transform(valueConfig: any, operator: string, valueRow: any): boolean {
        switch (operator) {
          case '!==':
            return valueConfig !== valueRow;
          case '===':
            return valueConfig === valueRow;
          case '>':
            return valueConfig > valueRow;
          case '<':
            return valueConfig < valueRow;
          default:
            throw new Error('Unsupported operator');
        }
      }
}
